import jwt from '@/auth/jwt/useJwt'
import { computed, ref } from '@vue/composition-api'
import Vue from 'vue'

export default function Users() {
  const route = 'users'
  const user = ref({ accessScope: 'organization', roles: [] })

  const formattedUser = computed(() => ({
    ...user.value,
    roles: user.value.roles.map(role => role.name),
  }))

  const indexRequest = params => jwt.axiosIns.get(route, { params }).then(res => res).catch(() => [])

  const indexOrganizationsRequest = (id, params) => jwt.axiosIns.get(`/organization/users/${id}`, { params }).then(res => res).catch(() => [])

  const indexGuestUsersRequest = (orgId, params) => jwt.axiosIns.get(`/organization/${orgId}/invitations`, { params }).then(res => res).catch(() => [])

  const showRequest = id => jwt.axiosIns.get(`${route}/${id}`).then(res => res).catch(() => [])

  const storeRequest = () => jwt.axiosIns.post(route, formattedUser.value).then(res => res)

  const inviteRequest = organizationId => jwt.axiosIns.post(`${route}/invite`, {
    ...formattedUser.value,
    events: formattedUser.value.events?.map(event => event.id),
    organizationID: organizationId,
  }).then(res => res)

  const getInvitationRequest = token => jwt.axiosIns.get(`${route}/invite/accept/${token}`).then(res => res)

  const acceptInvitationRequest = token => jwt.axiosIns.post(`${route}/invite/accept/${token}`).then(res => res)

  const updateRequest = () => jwt.axiosIns.put(`${route}/${user.value.id}`, formattedUser.value).then(res => res)

  const toggleRequest = id => jwt.axiosIns.put(`${route}/${id}/status`).then(res => res)

  const toggleEventLike = id => jwt.axiosIns.get(`user/toggle-like/${id}`).then(res => res)

  const removeUserFromOrgRequest = id => jwt.axiosIns.delete(`user/${id}/organization/${Vue.prototype.$orgId}`).then(res => res)
  const removeUserInvitation = id => jwt.axiosIns.delete(`users/invitation/${id}`).then(res => res)

  return {
    user, indexRequest, indexOrganizationsRequest, showRequest, storeRequest, inviteRequest, getInvitationRequest, acceptInvitationRequest, updateRequest, toggleRequest, removeUserFromOrgRequest, removeUserInvitation, indexGuestUsersRequest, toggleEventLike,
  }
}
